import React, { useState } from 'react';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { InputGroup, Button, InputBase } from '../../../../../../../common/@roma/src';
import { useDispatch } from 'react-redux';
import { updateTag } from '../../../../../../../common/tags/tagActions';

type Props = {
    tag: Tag;
    closePopup: () => void;
};

const TagRenameField: React.FC<Props> = ({ tag, closePopup }) => {
    const [name, setName] = useState<string>(tag.name);
    const dispatch = useDispatch();

    const handleNameChange = () => {
        dispatch(updateTag(tag.id, { name }));
        closePopup();
    };

    return (
        <InputGroup
            size="sm"
            aria-label="Edit tag name"
            onChange={setName}
            trailingAddon={
                <Button color="primary" size="sm" onClick={handleNameChange} isDisabled={!name}>
                    Update
                </Button>
            }
        >
            <InputBase type="text" placeholder="Edit name" value={name} />
        </InputGroup>
    );
};

export default TagRenameField;
